export default __webpack_public_path__ + "static/media/svg1.365f7b4a.svg";